import React, { forwardRef } from 'react';

const Textarea = forwardRef(({ name }, ref) => {
    return <textarea className="textarea" name={name} id={name} ref={ref}></textarea>
})

export default Textarea;